
import Vue from 'vue';

import NavBar from './components/NavBar.vue'
import HomeBanner from './components/HomeBanner.vue'
import Articulo from './components/Articulo.vue'
import CatalogToolbar from './components/CatalogToolbar.vue'
import {
  CATALOG_ACTIVE_OCCASION_PATH,
  CATALOG_ACTIVE_OCCASION_URL,
} from './config/catalog'

const CATALOG_SIGNUP_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://plataforma.chileconverge.cl/catalogo'
    : 'http://localhost:3000/catalogo';

type ActiveCatalogOccasion = {
  id?: number | string;
  name?: string;
  bannerImage?: string;
  bannerImagePreviewUrl?: string;
} | null;

export default Vue.extend({
  name: 'App',

  components: {
    NavBar,
    HomeBanner,
    Articulo,
    CatalogToolbar,
  },

  data: (): {
    hasActiveCatalogFilters: boolean;
    activeCatalogOccasion: ActiveCatalogOccasion;
  } => ({
    hasActiveCatalogFilters: false,
    activeCatalogOccasion: null,
  }),

  computed: {
    catalogSignupUrl(): string {
      return CATALOG_SIGNUP_URL;
    },
    activeCatalogOccasionName(): string {
      return this.activeCatalogOccasion?.name || '';
    },
    featuredSectionTitle(): string {
      return this.activeCatalogOccasionName
        ? `Destacados del ${this.activeCatalogOccasionName}`
        : 'Destacados de hoy';
    },
  },

  created() {
    this.fetchActiveCatalogOccasion();
  },

  mounted() {
    const trackRouteChange = () => {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_path: window.location.pathname + window.location.search + window.location.hash,
          page_location: window.location.href,
          page_title: document.title,
        });
      }
    };
    (this as any).routeChangeHandler = trackRouteChange;
    window.addEventListener('popstate', trackRouteChange);
    window.addEventListener('hashchange', trackRouteChange);
  },

  beforeDestroy() {
    const handler = (this as any).routeChangeHandler;
    if (handler) {
      window.removeEventListener('popstate', handler);
      window.removeEventListener('hashchange', handler);
    }
  },

  methods: {
    async fetchActiveCatalogOccasion() {
      try {
        const response = await fetch(
          CATALOG_ACTIVE_OCCASION_URL || CATALOG_ACTIVE_OCCASION_PATH
        );

        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        const payload = await response.json();
        this.activeCatalogOccasion = payload?.occasion || null;
      } catch (error) {
        console.error('Error loading active catalog occasion', error);
        this.activeCatalogOccasion = null;
      }
    },
    handleCatalogFiltersStateChange(hasActiveFilters: boolean) {
      this.hasActiveCatalogFilters = hasActiveFilters;
    },
    scrollToCatalog() {
      if (typeof window === 'undefined') {
        return;
      }

      const catalogSection = document.getElementById('catalogo');

      if (!catalogSection) {
        return;
      }

      const navbarOffset = 96;
      const top =
        catalogSection.getBoundingClientRect().top +
        window.pageYOffset -
        navbarOffset;

      window.scrollTo({
        top: Math.max(top, 0),
        behavior: 'smooth',
      });
    },
  },
});
